<i
	aria-hidden="true"
	aria-roledescription="button"
	data-test="newTaskButton"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="right"
	role="button"
	[class]="iconClass"
	[matTooltip]="help"
	[matTooltipDisabled]="!help"
	[matTooltipShowDelay]="500"
>
</i>
<p><ng-content /></p>
